import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let cachedCalendlyUrl = null;
let inFlight = null;

async function fetchConfig() {
    if (cachedCalendlyUrl !== null) return cachedCalendlyUrl;
    if (inFlight) return inFlight;
    inFlight = axios
        .get(`${BACKEND_URL}/api/config`)
        .then((r) => {
            cachedCalendlyUrl = r.data?.calendly_url || "";
            return cachedCalendlyUrl;
        })
        .catch(() => {
            cachedCalendlyUrl = "";
            return "";
        })
        .finally(() => {
            inFlight = null;
        });
    return inFlight;
}

export function useCalendlyUrl() {
    const [url, setUrl] = useState(cachedCalendlyUrl || "");
    useEffect(() => {
        let cancelled = false;
        fetchConfig().then((u) => {
            if (!cancelled) setUrl(u);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return url;
}

export function openCalendly(url) {
    if (!url) return;
    if (typeof window !== "undefined" && window.Calendly?.initPopupWidget) {
        window.Calendly.initPopupWidget({ url });
    } else {
        // Graceful fallback if the widget script hasn't loaded yet
        window.open(url, "_blank", "noopener,noreferrer");
    }
}
